import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IEquipmentType, IWorkPpr } from './interfaces';

export const getWorkPprList = (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<IWorkPpr[]>('/dictionary/work/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getWorkPprListAll = () => {
  return instance(true, PPR_API_URL)
    .get<IWorkPpr[]>('/dictionary/work/listAll')
    .then((response) => response.data);
};

export const getWorkPprAvailableColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/dictionary/work/availableColumns')
    .then((response) => response.data);
};

export const getWorkPprAvailableGroupColumns = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/dictionary/work/availableGroupColumns')
    .then((response) => response.data);
};

export const loadWorkPpr = (workId: number) => {
  return instance(true, PPR_API_URL)
    .get<IWorkPpr>('/dictionary/work/load/' + workId)
    .then((response) => response.data);
};

export const createWorkPpr = (work: IWorkPpr) => {
  return instance(true, PPR_API_URL)
    .post<IWorkPpr>('/dictionary/work/create', work)
    .then((response) => response.data);
};

export const updateWorkPpr = (work: IWorkPpr) => {
  return instance(true, PPR_API_URL)
    .post<IWorkPpr>('/dictionary/work/update/' + work.workId, work)
    .then((response) => response.data);
};

export const archiveWorkPpr = (workId: number, isDeleted: boolean) => {
  return instance(true, PPR_API_URL)
    .post('/dictionary/work/deleted/' + workId, { isDeleted })
    .then((response) => response.data);
};

export const getEquipmentTypeListAll = () => {
  return instance(true, PPR_API_URL)
    .get<IEquipmentType[]>('/dictionary/equipmentType/listAll')
    .then((response) => response.data);
};
